export const namespaced = true

export const state = {

    loggedIn: false,
    rol: null,
    user: {}
}